export const NAME = 'announcement';
